module.exports = __webpack_public_path__ + "d1bed0bbb3ee44cbbe454d924ed1df89.MP3";